/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_TitleInputs */

const en_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Data Processing`)
};

const de_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Datenverarbeitung`)
};

const fr_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Traitement des données`)
};

const es_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Procesamiento de datos`)
};

const it_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Trattamento dei dati`)
};

const nl_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Gegevensverwerking`)
};

const pl_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Przetwarzanie danych`)
};

const fi_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Tietojenkäsittely`)
};

const da_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Databehandling`)
};

const sv_privacy_data_processing_title = /** @type {(inputs: Privacy_Data_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Databehandling`)
};

/**
* | output |
* | --- |
* | "2. Data Processing" |
*
* @param {Privacy_Data_Processing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_title = /** @type {((inputs?: Privacy_Data_Processing_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_title(inputs)
	if (locale === "fr") return fr_privacy_data_processing_title(inputs)
	if (locale === "es") return es_privacy_data_processing_title(inputs)
	if (locale === "it") return it_privacy_data_processing_title(inputs)
	if (locale === "nl") return nl_privacy_data_processing_title(inputs)
	if (locale === "pl") return pl_privacy_data_processing_title(inputs)
	if (locale === "fi") return fi_privacy_data_processing_title(inputs)
	if (locale === "da") return da_privacy_data_processing_title(inputs)
	if (locale === "sv") return sv_privacy_data_processing_title(inputs)
	return en_privacy_data_processing_title(inputs)
});